import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { id } from '@wonder-core-ng/interfaces/id.type';
import { Observable } from 'rxjs';
import { BI_CORE_CONFIG } from '../config';
import { ICondition, ICreateConditionDTO } from './interfaces/condition.interface';

@Injectable({
  providedIn: 'root',
})
export class ConditionApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject(BI_CORE_CONFIG);

  private readonly route = `${this.config.apiBaseUrl}/conditions`;

  getAllConditions(tenantId: id): Observable<ICondition[]> {
    return this.httpClient.get<ICondition[]>(this.route, { headers: this.headers(tenantId) });
  }

  getConditionById(conditionId: string, tenantId: id): Observable<ICondition> {
    return this.httpClient.get<ICondition>(`${this.route}/${conditionId}`, {
      headers: this.headers(tenantId),
    });
  }

  createCondition(dto: ICreateConditionDTO, tenantId: id): Observable<ICondition> {
    return this.httpClient.post<ICondition>(this.route, dto, { headers: this.headers(tenantId) });
  }

  updateCondition(
    conditionId: string,
    dto: Partial<ICreateConditionDTO>,
    tenantId: id
  ): Observable<ICondition> {
    return this.httpClient.put<ICondition>(`${this.route}/${conditionId}`, dto, {
      headers: this.headers(tenantId),
    });
  }

  deleteCondition(conditionId: string, tenantId: id): Observable<void> {
    return this.httpClient.delete<void>(`${this.route}/${conditionId}`, {
      headers: this.headers(tenantId),
    });
  }

  private headers(tenantId: id): { [header: string]: string } {
    return { 'x-tenant-id': `${tenantId}` };
  }
}
